(() => {
  'use strict';
  if (window.__nsStudioBound) return;
  window.__nsStudioBound = true;
  const strings = window.nsStudioStrings || {};
  const root = window.routes?.root_url || '/';
  const endpoint = (path) => root.replace(/\/?$/, '/') + path;
  const status = (form, message) => {
    const node = form?.querySelector('[data-ns-form-status]');
    if (node) node.textContent = message;
  };
  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-ns-qty]');
    if (quantityButton) {
      const input = quantityButton.closest('.ns-quantity')?.querySelector('input');
      if (input) {
        const direction = Number(quantityButton.dataset.nsQty);
        const step = Number(input.step) || 1;
        const min = Number(input.min) || 0;
        const max = input.max === '' ? Infinity : Number(input.max);
        input.value = String(Math.min(max, Math.max(min, (Number(input.value) || min) + direction * step)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const gridButton = event.target.closest('[data-ns-columns]');
    if (gridButton) {
      const section = gridButton.closest('.ns-collection-main');
      const grid = section?.querySelector('[data-ns-product-grid]');
      if (grid) {
        grid.dataset.columns = gridButton.dataset.nsColumns;
        section.querySelectorAll('[data-ns-columns]').forEach(button => button.setAttribute('aria-pressed', String(button === gridButton)));
      }
    }
    const mediaButton = event.target.closest('[data-ns-media-target]');
    if (mediaButton) {
      const section = mediaButton.closest('[data-ns-product]');
      section.querySelectorAll('[data-ns-media]').forEach(media => {
        media.hidden = media.dataset.nsMedia !== mediaButton.dataset.nsMediaTarget;
        if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
      });
      section.querySelectorAll('[data-ns-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button === mediaButton)));
    }
  });
  let variantRequest;
  document.addEventListener('change', async (event) => {
    if (event.target.matches('[data-ns-sort]')) {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      location.assign(url.href);
    }
    if (!event.target.matches('[data-ns-option]')) return;
    const section = event.target.closest('[data-ns-product]');
    const focusedId = event.target.id;
    const quantity = section.querySelector('[name=quantity]')?.value;
    const optionIds = [...section.querySelectorAll('[data-ns-option]')].map(select => select.value);
    const url = new URL(location.href);
    url.searchParams.set('option_values', optionIds.join(','));
    url.searchParams.delete('variant');
    const renderUrl = new URL(url);
    renderUrl.searchParams.set('section_id', section.dataset.sectionId);
    variantRequest?.abort();
    const controller = new AbortController();
    variantRequest = controller;
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('[type=submit]').forEach(button => button.disabled = true);
    try {
      const response = await fetch(renderUrl, { signal: controller.signal });
      if (!response.ok) throw new Error(strings.option_error);
      const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = documentCopy.querySelector('[data-ns-product]');
      if (!replacement) throw new Error(strings.option_error);
      const replacementQuantity = replacement.querySelector('[name=quantity]');
      if (replacementQuantity && quantity) {
        const min = Number(replacementQuantity.min) || 1;
        const step = Number(replacementQuantity.step) || 1;
        const max = Number(replacementQuantity.max) || Infinity;
        replacementQuantity.value = String(Math.min(max, min + Math.max(0, Math.floor((Number(quantity) - min) / step)) * step));
      }
      section.replaceWith(replacement);
      history.replaceState({}, '', url);
      document.getElementById(focusedId)?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') {
        status(section.querySelector('form'), error.message);
        // Do not re-enable an old variant after a failed option change.
      }
    } finally {
      if (!controller.signal.aborted) section.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ns-cart-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const button = form.querySelector('[type=submit]');
    if (!button || button.disabled) return;
    form.dataset.pending = 'true';
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = strings.adding;
    status(form, '');
    try {
      const drawer = document.querySelector('cart-drawer');
      const data = new FormData(form);
      if (drawer?.getSectionsToRender) {
        data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.set('sections_url', location.pathname);
        drawer.setActiveElement?.(button);
      }
      const response = await fetch(endpoint('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const added = await response.json();
      if (!response.ok || added.status) throw new Error(added.description || strings.add_error);
      if (drawer?.renderContents && added.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(added, { open: false });
        drawer.showAddedToast?.(added);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ns-studio', cartData: added });
      }
      status(form, form.closest('.ns-card') ? '' : strings.added_status);
      button.textContent = strings.added;
      const cartResponse = await fetch(endpoint('cart.js'), { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count],.cart-count-bubble span:first-child').forEach(node => node.textContent = cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      }
    } catch (error) {
      status(form, error.message);
    } finally {
      form.dataset.pending = 'false';
      setTimeout(() => { button.disabled = false; button.textContent = originalText; }, 1200);
    }
  });
  const syncSearchPosition = () => {
    const header = document.querySelector('#header-component');
    const bottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    document.querySelectorAll('[data-ns-search]').forEach(drawer => {
      drawer.style.setProperty('--ns-search-offset', Math.round(bottom) + 'px');
    });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('side-drawer-opener[data-side-drawer="#Drawer-Search"]')) syncSearchPosition();
  }, true);
  window.addEventListener('resize', syncSearchPosition);
  const init = () => {
    const searchDrawers = document.querySelectorAll('[data-ns-search]');
    searchDrawers.forEach((drawer, index) => {
      if (index > 0) drawer.remove();
    });
    syncSearchPosition();
    document.querySelectorAll('[data-ns-mobile-filters]:not([data-ns-filters-initialized])').forEach(details => {
      if (matchMedia('(max-width:749px)').matches) details.removeAttribute('open');
      details.setAttribute('data-ns-filters-initialized', '');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

